export default __webpack_public_path__ + "static/media/Arya_Madan.c6dc7852.jpg";